"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visColorsLightHighContrast = void 0;
var _semantic_colors = require("./_semantic_colors");
var _primitive_colors = require("./_primitive_colors");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */
var baseColorVis = {
  euiColorVis0: _semantic_colors.SEMANTIC_COLORS.accentSecondary110,
  euiColorVis1: _semantic_colors.SEMANTIC_COLORS.accentSecondary80,
  euiColorVis2: _semantic_colors.SEMANTIC_COLORS.primary110,
  euiColorVis3: _semantic_colors.SEMANTIC_COLORS.primary80,
  euiColorVis4: _semantic_colors.SEMANTIC_COLORS.accent110,
  euiColorVis5: _semantic_colors.SEMANTIC_COLORS.accent80,
  euiColorVis6: _semantic_colors.SEMANTIC_COLORS.danger110,
  euiColorVis7: _semantic_colors.SEMANTIC_COLORS.danger80,
  euiColorVis8: _semantic_colors.SEMANTIC_COLORS.warning110,
  euiColorVis9: _semantic_colors.SEMANTIC_COLORS.warning80
};
var visColorsLightHighContrast = exports.visColorsLightHighContrast = _objectSpread(_objectSpread({}, baseColorVis), {}, {
  euiColorVisBehindText0: baseColorVis.euiColorVis0,
  euiColorVisBehindText1: baseColorVis.euiColorVis1,
  euiColorVisBehindText2: baseColorVis.euiColorVis2,
  euiColorVisBehindText3: baseColorVis.euiColorVis3,
  euiColorVisBehindText4: baseColorVis.euiColorVis4,
  euiColorVisBehindText5: baseColorVis.euiColorVis5,
  euiColorVisBehindText6: baseColorVis.euiColorVis6,
  euiColorVisBehindText7: baseColorVis.euiColorVis7,
  euiColorVisBehindText8: baseColorVis.euiColorVis8,
  euiColorVisBehindText9: baseColorVis.euiColorVis9,
  euiColorVisText0: _semantic_colors.SEMANTIC_COLORS.accentSecondary110,
  euiColorVisText1: _semantic_colors.SEMANTIC_COLORS.accentSecondary100,
  euiColorVisText2: _semantic_colors.SEMANTIC_COLORS.primary110,
  euiColorVisText3: _semantic_colors.SEMANTIC_COLORS.primary90,
  euiColorVisText4: _semantic_colors.SEMANTIC_COLORS.accent100,
  euiColorVisText5: _semantic_colors.SEMANTIC_COLORS.accent80,
  euiColorVisText6: _semantic_colors.SEMANTIC_COLORS.danger100,
  euiColorVisText7: _semantic_colors.SEMANTIC_COLORS.danger80,
  euiColorVisText8: _semantic_colors.SEMANTIC_COLORS.warning110,
  euiColorVisText9: _semantic_colors.SEMANTIC_COLORS.warning90,
  euiColorVisNeutral0: _semantic_colors.SEMANTIC_COLORS.neutral100,
  euiColorVisNeutral1: _semantic_colors.SEMANTIC_COLORS.neutral80,
  euiColorVisSuccess0: _semantic_colors.SEMANTIC_COLORS.success100,
  euiColorVisSuccess1: _semantic_colors.SEMANTIC_COLORS.success80,
  euiColorVisWarning0: _semantic_colors.SEMANTIC_COLORS.warning100,
  euiColorVisWarning1: _semantic_colors.SEMANTIC_COLORS.warning80,
  euiColorVisRisk0: _semantic_colors.SEMANTIC_COLORS.risk100,
  euiColorVisRisk1: _semantic_colors.SEMANTIC_COLORS.risk80,
  euiColorVisDanger0: _semantic_colors.SEMANTIC_COLORS.danger100,
  euiColorVisDanger1: _semantic_colors.SEMANTIC_COLORS.danger80,
  euiColorVisBase0: _primitive_colors.PRIMITIVE_COLORS.mutedGrey10,
  euiColorVisGrey0: _primitive_colors.PRIMITIVE_COLORS.blueGrey30,
  euiColorVisGrey1: _primitive_colors.PRIMITIVE_COLORS.blueGrey60,
  euiColorVisGrey2: _primitive_colors.PRIMITIVE_COLORS.blueGrey90,
  euiColorVisGrey3: _primitive_colors.PRIMITIVE_COLORS.blueGrey130,
  euiColorVisWarm0: _semantic_colors.SEMANTIC_COLORS.danger10,
  euiColorVisWarm1: _semantic_colors.SEMANTIC_COLORS.danger50,
  euiColorVisWarm2: _semantic_colors.SEMANTIC_COLORS.danger100,
  euiColorVisCool0: _semantic_colors.SEMANTIC_COLORS.primary10,
  euiColorVisCool1: _semantic_colors.SEMANTIC_COLORS.primary50,
  euiColorVisCool2: _semantic_colors.SEMANTIC_COLORS.primary100,
  euiColorVisComplementary0: _semantic_colors.SEMANTIC_COLORS.primary80,
  euiColorVisComplementary1: _semantic_colors.SEMANTIC_COLORS.warning80
});